// Application constants

export const APP_CONFIG = {
    name: 'GIS Analysis',
    version: '1.0.0',
    description: 'Automated GIS Spatial Analysis',
};

// File upload settings
export const UPLOAD_CONFIG = {
    maxFileSize: 50 * 1024 * 1024, // 50MB
    acceptedFormats: {
        'application/zip': ['.zip'],
        'application/x-zip-compressed': ['.zip'],
        'application/octet-stream': ['.shp', '.gpkg'],
        'application/geopackage+sqlite3': ['.gpkg'],
    },
    acceptedExtensions: ['.shp', '.zip', '.gpkg'],
};

// Processing steps configuration
export const PROCESSING_STEPS = [
    {
        id: 1,
        name: 'File Validation',
        description: 'Checking file integrity and format',
        duration: 2000, // ms
    },
    {
        id: 2,
        name: 'Data Extraction',
        description: 'Extracting geometry data from file',
        duration: 3000,
    },
    {
        id: 3,
        name: 'Spatial Analysis',
        description: 'Calculating area, perimeter, and coordinates',
        duration: 5000,
    },
    {
        id: 4,
        name: 'Interpretation',
        description: 'Generating analysis interpretation',
        duration: 3000,
    },
    {
        id: 5,
        name: 'Finalization',
        description: 'Preparing final results and report',
        duration: 2000,
    },
];

// Routes
export const ROUTES = {
    home: '/',
    upload: '/upload',
    processing: '/processing',
    results: '/results',
} as const;

// Feature list for landing page
export const FEATURES = [
    {
        icon: 'CloudUpload',
        title: 'Easy Upload',
        description: 'Drag & drop SHP, ZIP, or GPKG files easily',
    },
    {
        icon: 'Speed',
        title: 'Fast Analysis',
        description: 'Get analysis results in minutes',
    },
    {
        icon: 'PictureAsPdf',
        title: 'PDF Reports',
        description: 'Download complete results in professional PDF format',
    },
    {
        icon: 'Description',
        title: 'Interpretation',
        description: 'Easy to understand technical explanations',
    },
];

// How it works steps
export const HOW_IT_WORKS = [
    {
        step: 1,
        title: 'Upload File',
        description: 'Upload spatial file (SHP/ZIP/GPKG)',
    },
    {
        step: 2,
        title: 'Process',
        description: 'System analyzes data automatically',
    },
    {
        step: 3,
        title: 'View Results',
        description: 'Review analysis results and interpretation',
    },
    {
        step: 4,
        title: 'Download PDF',
        description: 'Download complete report in PDF',
    },
];
